import { ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../../core';
import { Icon, type IconType } from '../../icon';
import { theme } from './help_text.theme';

const elements = {
	helpText: styled.span`
		display: inline-flex;
		align-items: center;
		font: ${theme.getValue('baseFont')};
		color: ${theme.getValue('baseTextColor')};
		margin-top: ${theme.getValue('baseMarginTop')};

		&[data-invalid='false'] {
			color: ${theme.getValue('baseTextColor')};
		}

		&[data-invalid='true'] {
			color: ${theme.getValue('invalidTextColor')};
		}
	`,
	icon: styled(Icon)`
		margin-right: ${coreTokens.spacing.x0_5};
		flex-shrink: 0;
	`,
};

interface HelpTextProps extends HTMLAttributes<HTMLSpanElement> {
	children?: ReactNode;
	invalid?: boolean;

	/**
	 * An optional leading icon shown before the help text. Ignored while
	 * `invalid` is `true`, in which case the invalid warning icon is shown.
	 */
	icon?: IconType;
}

function CellulaHelpText({ children, invalid, icon, ...rest }: HelpTextProps, ref: ForwardedRef<HTMLSpanElement>): JSX.Element | null {
	if (!children) {
		return null;
	}

	const iconType = invalid ? 'warningCircle' : icon;

	return (
		<elements.helpText {...rest} data-invalid={invalid} ref={ref}>
			{iconType ? <elements.icon type={iconType} size='xSmall' /> : null}
			{children}
		</elements.helpText>
	);
}

const HelpText = forwardRef(CellulaHelpText);

export type { HelpTextProps };
export { HelpText };
